import React from 'react';
import cn from 'classnames';
import { AnchorLogo } from 'seagull/icons';
import styles from "./GenericError.module.scss";
export default function GenericError(props) {
  const {
    testid,
    fullPage
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.root, {
      [styles.fullPage]: fullPage
    }),
    "data-testid": testid
  }, /*#__PURE__*/React.createElement(AnchorLogo, {
    className: styles.logo
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.text
  }, "Something went wrong... Please try again later"));
}